var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"allTable"},[_c('Table',{attrs:{"border":"","columns":_vm.table.column,"data":_vm.listdata}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }